/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_Fast_ForwardInputs */

const en_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast Forward`)
};

const fr_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance rapide`)
};

const de_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellvorlauf`)
};

const it_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanti veloce`)
};

const ru_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемотка вперед`)
};

const es_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance rápido`)
};

const zh_cn2_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快进`)
};

const ja_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`早送り`)
};

const hi_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तेजी से आगे बढ़ना`)
};

const pt_pt2_options_pedal_action_fast_forward = /** @type {(inputs: Options_Pedal_Action_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanço rápido`)
};

/**
* | output |
* | --- |
* | "Fast Forward" |
*
* @param {Options_Pedal_Action_Fast_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_fast_forward = /** @type {((inputs?: Options_Pedal_Action_Fast_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_Fast_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_action_fast_forward(inputs)
	if (locale === "de") return de_options_pedal_action_fast_forward(inputs)
	if (locale === "it") return it_options_pedal_action_fast_forward(inputs)
	if (locale === "ru") return ru_options_pedal_action_fast_forward(inputs)
	if (locale === "es") return es_options_pedal_action_fast_forward(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_action_fast_forward(inputs)
	if (locale === "ja") return ja_options_pedal_action_fast_forward(inputs)
	if (locale === "hi") return hi_options_pedal_action_fast_forward(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_action_fast_forward(inputs)
	return en_options_pedal_action_fast_forward(inputs)
});